import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Icon, Card, Button, Grid, Input} from 'semantic-ui-react';
import {dateFormatPicker, noTimeZoneShortISODate} from '../../common/constants/datesFormat';
import {setErrorMessage, clearErrorMessage} from '../../common/components/form/common';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import PartAuditListTable from './table';

class PartAuditList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDateFilter': moment().format(noTimeZoneShortISODate),
      'endDateFilter': moment().format(noTimeZoneShortISODate),
      'code': '',
    };
    this.search = this.search.bind(this);
    this.donwload = this.donwload.bind(this);
    this.changeCode = this.changeCode.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
  }
  
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PartAudit, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.changeListPageSize(20);
    this.props.changeListPage(0);
    this.search();
  }

  getParameters() {
    const {startDateFilter, endDateFilter, code} = this.state;
    return {
      'startDate': startDateFilter,
      'endDate': endDateFilter,
      'partCode': code,
    };
  }

  search() {
    this.props.deletePartAudit();
    this.props.fetchPartAudit(this.getParameters());
  }

  donwload() {
    this.props.downloadPartAuditFile(this.getParameters());
  }

  changeStartDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted !== startDateFilter) {
      this.setState({'startDateFilter': dateFormatted});
    }
    
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  changeEndDate(date) {
    const dateFormatted = moment(date).format(noTimeZoneShortISODate);

    if (dateFormatted !== this.state.endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  }

  changeCode(partCode) {
    this.setState({'code': partCode.target.value.toUpperCase()});
  }

  renderSearchButton() {
    return (
      <Button
        primary
        className='toyota-primary'
        onClick = {this.search}
      >
        Consultar
      </Button>
      
    );
  }

  renderDownloadButton() {
    return (
      <Button
        primary
        className='toyota-primary download'
        onClick = {this.donwload}
      >
        <Icon name='download' />
      Descargar
      </Button>
    );
  }

  render() {
    const {code, startDateFilter, endDateFilter} = this.state;

    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta Auditoría Repuestos</h2>
              <div className='title-bar-actions'>
                {this.renderSearchButton()}
                {this.renderDownloadButton()}
              </div>
            </div>

            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={2}>
                    <h4>Código Parte:</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Input
                      required
                      value={code}
                      maxLength='100'
                      type='text'
                      onChange={this.changeCode}
                      onInvalid={(event) => setErrorMessage('Por favor, llene este campo', event)}
                      onInput={(event) => clearErrorMessage(event)}
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        startDateFilter ?
                          moment(startDateFilter, noTimeZoneShortISODate).toDate() :
                          null
                      }
                      onChange={this.changeStartDate}
                      locale='es'
                      placeholderText='Fecha Inicio'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        endDateFilter ?
                          moment(endDateFilter, noTimeZoneShortISODate).toDate() :
                          null
                      }
                      onChange={this.changeEndDate}
                      locale='es'
                      placeholderText='Fecha Fin'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <PartAuditListTable />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchPartAudit,
  deletePartAudit,
  changeListPage,
  changeListPageSize,
  downloadPartAuditFile,
  fetchPart,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchPartAudit,
  deletePartAudit,
  changeListPage,
  changeListPageSize,
  downloadPartAuditFile,
  fetchPart,
})(PartAuditList);
